import gql from 'graphql-tag';

export const getLeaderboardByAdmin = gql`
  query getLeaderboardByAdmin($id: Int!) {
    getLeaderboardByAdmin(id: $id) {
      id
      name
      periodFrom
      periodTo
      active
    }
  }
`;
